import { render, staticRenderFns } from "./ScreenFit.vue?vue&type=template&id=5c25f5e9&scoped=true"
import script from "./ScreenFit.vue?vue&type=script&lang=js"
export * from "./ScreenFit.vue?vue&type=script&lang=js"
import style0 from "./ScreenFit.vue?vue&type=style&index=0&id=5c25f5e9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c25f5e9",
  null
  
)

export default component.exports